import { render } from "./CompleteRegistration.vue?vue&type=template&id=7c79fdd4"
import script from "./CompleteRegistration.vue?vue&type=script&lang=js"
export * from "./CompleteRegistration.vue?vue&type=script&lang=js"
script.render = render

export default script